<svg class="main-svg" viewBox="0 0 24 24" [attr.fill]="fill" xmlns="http://www.w3.org/2000/svg">
  <path
    class="svg-path"
    d="M17.5623 8.95246L18.274 9.64613C18.5753 9.93985 18.5753 10.4148 18.274 10.7054L12.045 16.7797C11.7436 17.0734 11.2564 17.0734 10.9582 16.7797L4.72601 10.7054C4.42466 10.4117 4.42466 9.93673 4.72601 9.64613L5.43771 8.95246C5.74227 8.65562 6.23918 8.66187 6.53733 8.96496L10.2177 12.7302V3.74992C10.2177 3.33434 10.5607 3 10.9871 3H12.0129C12.4393 3 12.7823 3.33434 12.7823 3.74992V12.7302L16.4627 8.96496C16.7608 8.65874 17.2577 8.65249 17.5623 8.95246Z"
  />
  <rect x="2.5" y="19" width="18" height="2" rx="0.8" class="svg-path" />
</svg>
